'use client';

import React from 'react';
import {ImageBlockData} from '../../editorjs.types';
import styles from './ImagePlugin.module.scss';

interface ImagePluginProps {
  data: ImageBlockData;
  block: {
    data: ImageBlockData;
  }
}

const ImagePlugin: React.FC<ImagePluginProps> = ({block}) => {
  const {data} = block;

  const transformUrl = (url: string): string => {
    if (!url) return '';

    try {
      const newBase = process.env.NEXT_PUBLIC_URL;
      if (!newBase) return url;

      const parsedUrl = new URL(url, newBase); // корректно обрабатывает относительные URL
      const base = new URL(newBase);

      // подмена протокола, хоста и порта
      parsedUrl.protocol = base.protocol;
      parsedUrl.hostname = base.hostname;
      parsedUrl.port = base.port;

      return parsedUrl.toString();
    } catch (error) {
      // если url некорректный — вернуть как есть
      return url;
    }
  };

  const imageUrl = data.file?.url || data.url;
  const imageClasses = [
    styles.image,
    data.withBorder && styles.imageWithBorder,
    data.stretched && styles.imageStretched,
    data.withBackground && styles.imageWithBackground,
  ].filter(Boolean).join(' ');

  return (
    <figure className={styles.imageContainer}>
      <img
        src={transformUrl(imageUrl)}
        alt={data.caption || 'Изображение'}
        className={imageClasses}
        loading="lazy"
      />
      {data.caption && (
        <figcaption className={styles.caption}>{data.caption}</figcaption>
      )}
    </figure>
  );
};

export default ImagePlugin;